export default __webpack_public_path__ + "static/media/640_dummy2016-illustrator01-de.77820334.png";